import React, { useContext, useState } from "react";
import styled from "@emotion/styled";
import FilterBar from "../FilterBar";
import { Link } from "react-router-dom";
import Spinner from "../Spinner/Spinner";
import { getMovies } from "../../MovieQueries";
import FilterIcon from "../FilterBar/filter-icon.svg";

import { MovieContext } from "../../Context/MovieContext";

export default function Movies() {
  const { moviesList, setmoviesList } = useContext(MovieContext);

  const [ShowFilterBar, setShowFilterBar] = useState(false)
  return (
    <Container>
      <div className="toggle-btn" onClick={() => setShowFilterBar(!ShowFilterBar)}>
        <img src={FilterIcon} alt="" /> Filter
      </div>
      <FilterBar ShowFilterBar={ShowFilterBar} setShowFilterBar={setShowFilterBar}/>
      <h1 style={{ fontSize: "170%" }}>Movies</h1>
      <Grid>
        {moviesList.movies === null && <Spinner />}
        {moviesList.movies !== null &&
          moviesList.movies.length > 0 &&
          moviesList.movies.map((movie) => (
            <Link
              to={"/movies/" + movie.slug}
              style={{ textDecoration: "none", color: "#000000" }}
              key={movie.slug}
            >
              <Card>
                <img
                  src={
                    "//image.tmdb.org/t/p/w220_and_h330_face" +
                    movie.poster_path
                  }
                  alt=""
                  width="100%"
                />
                <div className="title">{movie.title}</div>
                <div className="year">{movie.movie_year.year}</div>
              </Card>
            </Link>
          ))}
        {moviesList.movies !== null && moviesList.movies.length === 0 && (
          <div>No Movies Available</div>
        )}
      </Grid>
      {moviesList.movies !== null &&
        moviesList.movies.length !== 0 &&
        moviesList.count > moviesList.start && (
          <div style={{display : "flex",justifyContent : "center"}}>
          <LoadMoreButton
            onClick={() =>
              getMovies(
                10,
                null,
                moviesList,
                setmoviesList,
                moviesList.query,
                "append",
                moviesList.start
              )
            }
          >
            Load More
          </LoadMoreButton>
          </div>
        )}
    </Container>
  );
}

const Container = styled.div`
  max-width: 100vw;
  padding: 20px 130px 20px 130px;
  flex : 0.9;
  .toggle-btn {
    display: flex;
    width: fit-content;
    & > img {
      display: inline;
      height: 16px;
      margin-right: 5px;
    }
    margin-right: 10px;
    background: #fcfcfc;
    padding: 13px;

    @media(min-width : 768px){
      display: none
    }
  }
  @media (max-width: 877px) {
    padding: 20px 20px;
  }
`;

const LoadMoreButton = styled.button`
padding: 10px 20px;
background: #1d0b5c;
border : none;
color : white;
margin-left : auto;
margin-right : auto;
cursor: pointer;
`

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Card = styled.div`
  margin: 10px 10px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 13vw;
  .title {
    font-weight: bold;
    font-size: 110%;
    padding: 5px 10px;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }
  .year {
    padding: 5px 10px;
    color: rgba(0, 0, 0, 0.8);
  }
  & > img {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  @media (max-width: 768px) {
    width: 41vw;
    height: auto;
    margin: 10px 5px;
  }
`;
